import React from 'react';
import styles from "./Accordion.module.scss";


const Accordion = ({ id, show, onShow, title, children }) => {

    const handleShow = () => onShow && onShow(id);
  
    return (

     <div className={`${styles.accordionItem}`}>
        <div className={`${styles.accordionTitle} ${show ? styles.open : ""}`} onClick={handleShow}>
          <div>{title}</div>
          <div>
          {show ? (<svg version="1.1" width="12px" height="2px" viewBox="0 0 12.0 2.0" xmlns="http://www.w3.org/2000/svg" ><g transform="translate(-1.0 -6.0)"><g transform="translate(1.0 7.5) rotate(-90.0)"><path d="M0.5,0 L0.5,12" stroke="#3F5363" strokeWidth="1" fill="none" strokeMiterlimit="10"></path></g></g></svg>) : (<svg version="1.1" width="12px" height="12px" viewBox="0 0 12.0 12.0" xmlns="http://www.w3.org/2000/svg" ><g transform="translate(-1.0 -1.0)"><g transform="translate(1.0 1.0)"><g transform="translate(5.5 0.0)"><path d="M0.5,0 L0.5,12" stroke="#3F5363" strokeWidth="1" fill="none" strokeMiterlimit="10"></path></g><g transform="translate(0.0 6.5) rotate(-90.0)"><path d="M0.5,0 L0.5,12" stroke="#3F5363" strokeWidth="1" fill="none" strokeMiterlimit="10"></path></g></g></g></svg>)
          }
          </div>
        </div>
        {show && <div className={styles.accordionContent}>{children}</div>}
      </div>
    );
  };
  
  export default Accordion;